export const LogoText: React.FC<{
  className?: string
  color?: string
}> = ({ className, color = '#FF4A0B' }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1142 507"
      className={className}
    >
      <g>
        <g>
          <path
            fill={color}
            d="M50.2,3v143c7.9-11.4,18.5-20.4,31.6-27c13.1-6.6,28-9.8,44.6-9.8c30.7,0,54.7,9.3,71.8,28
			c17.1,18.7,25.7,44.4,25.7,77.2v157h-47.2V223.2c0-22.1-5.1-39.2-15.3-51.3c-10.2-12.1-25.3-18.1-45.3-18.1
			c-19,0-34.7,6.4-47.2,19.2c-12.4,12.8-18.7,29.5-18.7,50.3v148.2H3V8.2L50.2,3z"
          />
        </g>
        <g>
          <path
            fill={color}
            d="M308,346.9c-16.8-18.5-25.1-44.3-25.1-77.5v-157H330V260c0,23.5,5.1,41,15.3,52.6
			c10.2,11.6,25.1,17.4,44.8,17.4c19,0,34.3-6.4,45.9-19.2c11.6-12.8,17.4-29.7,17.4-50.8V112.3h47.2v259.1h-47.2v-33.7
			c-7.3,10.7-17.2,19.5-29.8,26.4c-12.6,6.9-27.2,10.4-43.8,10.4C348.7,374.6,324.7,365.3,308,346.9z"
          />
        </g>
        <g>
          <path
            fill={color}
            d="M610.9,112.3v33.2c9.3-10.4,20.9-19,34.7-25.9c13.8-6.9,29.7-10.4,47.7-10.4c24.9,0,47,5.5,66.3,16.6
			c19.3,11.1,34.3,26.6,44.8,46.6c10.5,20,15.8,43.2,15.8,69.4s-5.3,49.4-15.8,69.4c-10.5,20-25.5,35.6-44.8,46.6
			c-19.4,11.1-41.5,16.6-66.3,16.6c-18,0-34-3.4-48.2-10.4c-14.2-6.9-25.6-15.6-34.2-25.9V501l-47.2,6.2V112.3H610.9z M751.1,304.9
			c15-16.4,22.5-37.4,22.5-63s-7.5-46.6-22.5-63c-15-16.4-34.8-24.6-59.3-24.6c-15.9,0-30.1,3.8-42.5,11.4
			c-12.4,7.6-22.1,18.1-29,31.4c-6.9,13.3-10.4,28.2-10.4,44.8c0,16.6,3.4,31.5,10.4,44.8c6.9,13.3,16.6,23.8,29,31.4
			c12.4,7.6,26.6,11.4,42.5,11.4C716.3,329.5,736,321.3,751.1,304.9z"
          />
        </g>
      </g>
      <path
        fill={color}
        d="M991.1,112.3c-72.2,0-130.7,58.5-130.7,130.7s58.5,130.7,130.7,130.7s130.7-58.5,130.7-130.7
	S1063.3,112.3,991.1,112.3z M1092.1,302.5c-31.3,12.2-65.3,19-100.9,19c-35.6,0-69.7-6.7-100.9-19l0-0.1c5-33.3,16.1-66.3,33.9-97.4
	c17.8-31.1,40.7-57.4,67-78.6l0,0.1c26.3,21.2,49.2,47.5,67,78.6C1075.9,236.2,1087.1,269.2,1092.1,302.5L1092.1,302.5L1092.1,302.5
	z"
      />
    </svg>
  )
}
